import React, { type JSX } from 'react';
import EDMenuButtonItem from '../../../../../../BaseComponents/Buttons/MenuButton/EDMenuButtonItem';
import EDListItemText from '../../../../../../BaseComponents/List/Components/EDListItemText';
import EDListItemIcon from '../../../../../../BaseComponents/List/Components/EDListItemIcon';
import EDIcon from '../../../../../../BaseComponents/Icon/EDIcon';
import { IconType } from '../../../../../../BaseComponents/Icon/Utils/IconDefinitions';

interface IProps {
  onClick?: () => void;
  disabled?: boolean;
  disabledReason?: React.ReactNode;
  confirmButtonCaption?: string;
  confirmDialogCaption?: string;
  confirmDialogMessage?: string | JSX.Element;
  iconType?: IconType;
  children: string | JSX.Element;
  /** Render listitemikon even if iconType is undefined, used to match margins with other items in the list who have icons */
  listItemIcon?: boolean;
  //Hämtas ut i EdLocalMenu.tsx
  testId?: String;
}

const FunctionItem: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => {
  const renderListItemIcon = props.listItemIcon || props.iconType;

  return (
    <EDMenuButtonItem
      onClick={props.onClick}
      disabled={props.disabled}
      disabledReason={props.disabledReason}
    >
      {renderListItemIcon && (
        <EDListItemIcon>
          {props.iconType && (
            <EDIcon color="action" iconType={props.iconType} />
          )}
        </EDListItemIcon>
      )}
      <EDListItemText
        noLeftPadding
        primaryTypographyProps={{ variant: 'body2' }}
      >
        {props.children}
      </EDListItemText>
    </EDMenuButtonItem>
  );
};

export default FunctionItem;
